
import '../App.css';
import React, { useState, useEffect, useRef, useMemo } from 'react';


import { submitMembershipForm } from "./Email.js"
import { useNavigate } from 'react-router-dom';
import { db } from '../config';
import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style
import moment from 'moment/moment';
import { FaUserFriends } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import waiting from '../loading.json'
import DatePicker from "react-datepicker";
import { FaUserTie } from "react-icons/fa";
import ReactModal from 'react-modal';
import { toast } from 'wc-toast'
import Select, { components } from 'react-select';
import { IoIosCloseCircle } from "react-icons/io";
import { decrypt, encrypt } from '../Crypto';
import { Button, Typography } from '@mui/material';
import { FaArrowLeftLong } from "react-icons/fa6";

import BG from "../bg.png";
import LOGO from "../logo_new.png";
import { LuSendToBack } from 'react-icons/lu';
import Lottie from 'lottie-react';

const height = window.innerHeight;
const width = window.innerWidth;
//console.log(height)
//console.log(width)

// ✅ Best way for React web: import images (more stable than require)
function Membership() {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);



    useEffect(() => {
        const onResize = () => {
            setScreenWidth(window.innerWidth);
            setScreenHeight(window.innerHeight);
        };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const isMobile = screenWidth <= 924;

    //////////////////// 1st part

    // ✅ scale based on the actual HERO width (no hard caps)
    const scale = (n) => {
        const heroPx = isMobile ? screenWidth : screenWidth * 0.97; // hero is 95% on desktop
        const DESIGN_W = 1832; // only used as a ratio reference (not a cap)

        const raw = heroPx / DESIGN_W;

        // keep it premium (avoid too small / too huge)
        const s = Math.max(0.85, Math.min(1.15, raw));

        return Math.round(n * s);
    };

    // ✅ white spacing around hero (top = sides)
    const pagePad = isMobile ? 14 : Math.max(18, Math.min(44, screenWidth * 0.022));

    // ✅ figma ratio (only ratio, not fixed px)
    const FIGMA_W = 1832;
    const FIGMA_H = 1004;
    const FIGMA_RATIO = FIGMA_H / FIGMA_W; // ≈ 0.548

    // ✅ Desktop width is % (no max), Mobile is 95%
    const heroW = isMobile ? "97%" : `${Math.round(95)}%`;

    // ✅ Hero pixel width (needed for height calc + scaling)
    const heroWpx = isMobile
        ? Math.round(screenWidth * 0.97)
        : Math.round(screenWidth * 0.97);

    // ✅ keep same ratio for height on desktop, safe min-height on mobile
    const heroMinH = isMobile
        ? Math.max(640, Math.round(screenHeight * 0.82))
        : Math.round(heroWpx * FIGMA_RATIO);

    // ✅ inner padding inside hero (also controls bottom-right spacing of cards)
    const heroInset = isMobile ? 14 : 22;

    const headerRowH = isMobile ? 56 : 70;

    const navigate = useNavigate();


    const pressDown = (e) => {
        e.currentTarget.style.transform = "scale(0.98)";
    };

    const pressUp = (e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.background = "rgba(255,255,255,0.12)";
    };

    const hoverIn = (e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.16)";
    };

    const hoverIn1 = (e) => {
        e.currentTarget.style.background = "#2a9bc6";
    };

    const hoverIn2 = (e) => {
        e.currentTarget.style.background = "#206B8A";
    };

    const hoverOut = (e) => {
        e.currentTarget.style.background = "transparent";
    };


    const hoverOut2 = (e) => {
        e.currentTarget.style.background = "#2a9bc6";
    };


    const hoverOut3 = (e) => {
        e.currentTarget.style.background = "transparent";
    };



    const hoverOut4 = (e) => {
        e.currentTarget.style.background = "#2A8FB8";
    };

    const hoverOut1 = (e) => {
        e.currentTarget.style.background = "rgba(42,155,198,0.88)";
    };



    /* =========================
✅ COPY/PASTE (BEFORE RETURN) — WITH AUTO SCROLL + FOCUS + AUTO DOB MODAL
========================= */


    // //////////////////////// Calender
    const [update_date, setUpdate_date] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [BDate, setBDate] = useState(null);

    const pad2 = (n) => String(n).padStart(2, "0");
    const formatDDMMYYYY = (d) =>
        d ? `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()}` : "";

    // //////

    const [load, setLoad] = useState(false);

    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [code, setCode] = useState("");
    const [tele, setTele] = useState("");
    const [mob, setMob] = useState("");
    const [email, setEmail] = useState("");

    const [e_name, setEname] = useState("");
    const [c_no, setC_no] = useState("");

    const [e_name_2, setEname_2] = useState("");
    const [c_no_2, setC_no_2] = useState("");

    const [medi_his, setMedi_his] = useState("");

    const [r_name, setRname] = useState("");
    const [r_no, setR_no] = useState("");

    const [selfDisclosure, setSelfDisclosure] = useState(null);
    // null = not selected, true = Yes, false = No

    // ✅ red-border validation state
    const [errors, setErrors] = useState({});

    const baseBorder = "1px solid rgba(15,23,42,0.14)";
    const errorBorder = "1.6px solid #EF4444"; // red

    // ✅ NEW: refs for scroll + focus
    const fieldRefs = useRef({});

    const setFieldRef = (key) => (el) => {
        if (el) fieldRefs.current[key] = el;
    };

    // ✅ order of fields (top-to-bottom)
    const fieldOrder = [
        "name",
        "dob",
        "address",
        "code",
        "tele",
        "mob",
        "email",
        "e_name",
        "c_no",
        "e_name_2",
        "c_no_2",
        "medi_his",
        "selfDisclosure",
        "r_name",
        "r_no",
    ];

    const focusFirstError = (nextErrors) => {
        const firstKey = fieldOrder.find((k) => nextErrors?.[k]);
        if (!firstKey) return;

        // ✅ if DOB missing, open modal automatically
        if (firstKey === "dob") setUpdate_date(true);

        requestAnimationFrame(() => {
            const el = fieldRefs.current[firstKey];
            if (!el) return;

            // smooth scroll to element
            try {
                el.scrollIntoView?.({ behavior: "smooth", block: "center" });
            } catch (e) { }

            // focus if possible
            try {
                el.focus?.({ preventScroll: true });
            } catch (e) { }
        });
    };

    // ✅ helper: updates value + clears red border when fixed
    const setField = (key, setter) => (e) => {
        const v = e.target.value;
        setter(v);

        setErrors((prev) => {
            if (!prev?.[key]) return prev;
            return { ...prev, [key]: false };
        });
    };

    // ✅ validate all required fields + set errors + auto focus first invalid
    const validateMembership = () => {
        const next = {
            name: !name.trim(),
            dob: !startDate,
            address: !address.trim(),
            code: !code.trim(),
            tele: !tele.trim(),
            mob: !mob.trim(),
            email: !email.trim(),
            e_name: !e_name.trim(),
            c_no: !c_no.trim(),
            e_name_2: !e_name_2.trim(),
            c_no_2: !c_no_2.trim(),
            medi_his: !medi_his.trim(),
            r_name: !r_name.trim(),
            r_no: !r_no.trim(),
            selfDisclosure: selfDisclosure === null,
        };

        setErrors(next);

        const ok = !Object.values(next).some(Boolean);
        if (!ok) focusFirstError(next);

        return ok;
    };

    // Membership submit
    async function onSubmitMembership(e) {
        const ok = validateMembership();

        if (!ok) {
            toast.error("Please fill up all required info");
            setLoad(false);
            return;
        }

        setLoad(true);
        try {
            await submitMembershipForm({
                to: "alanbythesea@outlook.com",
                fullName: name,
                dob: BDate, // ✅ keep DOB as DD/MM/YYYY string
                address: address,
                postcode: code,
                homeTelephone: tele,
                mobile: mob,
                email: email,
                emergencyName: e_name,
                emergencyContact: c_no,
                altName: e_name_2,
                altContact: c_no_2,
                medicalHistory: medi_his,
                selfDisclosureAnswer: selfDisclosure === true ? "Yes" : "No",
                selfDisclosureDetails: selfDisclosure === true ? "Yes" : "No",
                referenceName: r_name,
                referenceContact: r_no,
            });

            setLoad(false);
            toast.success("Your application has been submitted");
            navigate("/");
        } catch (err) {
            alert(err.message);
            setLoad(false);
        }
    }

    /* =========================
    ✅ IMPORTANT: YOU MUST ADD REFS IN JSX (inside return)
    Example:
    <input ref={setFieldRef("name")} ... />
    DOB wrapper: <div ref={setFieldRef("dob")} tabIndex={-1} ... />
    <textarea ref={setFieldRef("address")} ... />
    SelfDisclosure box: <div ref={setFieldRef("selfDisclosure")} tabIndex={-1} ... />
    ...and so on for other fields using their keys.
    ========================= */


    return (
        <div
            style={{
                minHeight: "100dvh",
                background: "#ffffff",
                boxSizing: "border-box",

                // ✅ equal white space all around + safe-area
                paddingTop: `calc(${pagePad}px + env(safe-area-inset-top))`,
                paddingBottom: `calc(${pagePad}px + env(safe-area-inset-bottom))`,
                paddingLeft: `calc(${pagePad}px + env(safe-area-inset-left))`,
                paddingRight: `calc(${pagePad}px + env(safe-area-inset-right))`,

                display: "flex",
                justifyContent: 'flex-start',
                alignItems: "flex-start",
                flexDirection: 'column'
            }}
        >

            {/* ✅ Back to Home (below) */}
            <div
                style={{
                    position: "absolute",
                    left: isMobile ? 10 : 14,
                    //  right: 10,
                    top: isMobile ? 10 : 16,   // adjust if needed
                    display: "flex",
                    justifyContent: "flex-start",
                    pointerEvents: "none",     // allows button only to receive clicks
                    fontFamily: "Plus Jakarta Sans",
                    zIndex: 50,
                }}
            >
                <button
                    type="button"
                    onClick={() => navigate("/")}
                    style={{
                        pointerEvents: "auto",
                        height: isMobile ? 34 : 42,
                        padding: isMobile ? "0 8px" : "0 18px",
                        borderRadius: 8,
                        border: "none",
                        cursor: "pointer",
                        background: "#2A8FB8",
                        color: "#EAF4F8",
                        fontSize: isMobile ? 13 : 18,
                        fontWeight: 700,
                        letterSpacing: 0.2,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 10,
                        boxShadow: "0 14px 34px rgba(0,0,0,0.18)",
                        fontFamily: "Plus Jakarta Sans",
                    }}


                    onMouseDown={pressDown}
                    onMouseUp={pressUp}
                    onMouseEnter={hoverIn1}
                    onMouseLeave={hoverOut4}
                    onTouchStart={pressDown}
                    onTouchEnd={pressUp}
                >
                    <FaArrowLeftLong color="#EAF4F8" />
                    Back to Home
                </button>
            </div>









            {/* ✅ MEMBERSHIP APPLICATION HEADER (below Back to Home) */}
            <div
                style={{
                    width: isMobile ? "95%" : Math.round(screenWidth * 0.94),
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 50 : 0,
                    textAlign: "center",
                    fontFamily: "Plus Jakarta Sans",

                }}
            >
                <div
                    style={{
                        fontSize: isMobile ? 20 : 40,
                        fontWeight: 700,
                        //  letterSpacing: 1.5,
                        color: "#0F172B",
                        textTransform: "uppercase",
                        fontFamily: "Plus Jakarta Sans",
                    }}
                >
                    Application For
                </div>

                <div
                    style={{
                        marginTop: 0,
                        fontSize: isMobile ? 20 : 40,
                        fontWeight: 700,
                        //  letterSpacing: 1.2,
                        color: "#2B8EB8",
                        textTransform: "uppercase",
                        fontFamily: "Plus Jakarta Sans",
                    }}
                >
                    West Wittering Short Mat Bowls Club
                </div>

                <div
                    style={{
                        marginTop: 0,
                        fontSize: isMobile ? 20 : 40,
                        fontWeight: 700,
                        //   letterSpacing: 1.3,
                        color: "#0F172B",
                        textTransform: "uppercase",
                        fontFamily: "Plus Jakarta Sans",
                        marginBottom: isMobile ? 25 : 50
                    }}
                >
                    Membership
                </div>
            </div>

            {/* ✅ MEMBERSHIP FORM SECTION (below the big membership heading) */}
            <div
                style={{
                    width: isMobile ? "95%" : Math.round(screenWidth * 0.65),
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 18 : 28,
                    display: "grid",
                    gridTemplateColumns: isMobile ? "1fr" : "1fr",
                    gap: isMobile ? 16 : 22,
                    alignItems: "start",
                    fontFamily: "Plus Jakarta Sans",
                }}
            >
                {/* LEFT: BIG FORM CARD */}
                <div
                    style={{
                        background: "#FFFFFF",
                        borderRadius: 22,
                        border: "1px solid rgba(15,23,42,0.08)",
                        boxShadow: "0 30px 80px rgba(0,0,0,0.12)",
                        padding: isMobile ? 16 : 22,
                        fontFamily: "Plus Jakarta Sans",
                    }}
                >
                    {/* Row 1: Full Name + DOB */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: isMobile ? "1fr" : "1.25fr 0.55fr",
                            gap: 16,
                            fontFamily: "Plus Jakarta Sans",
                        }}
                    >
                        {/* Full Name */}
                        <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "rgba(15,23,42,0.70)",
                                    fontWeight: 500,
                                    marginBottom: 8,
                                    textAlign: "left",
                                    fontFamily: "Plus Jakarta Sans",
                                }}
                            >
                                Full Name
                            </div>
                            <input
                                ref={setFieldRef("name")}
                                placeholder="Your Full Name"
                                value={name}
                                onChange={setField("name", setName)}
                                style={{
                                    width: "100%",
                                    height: 44,
                                    borderRadius: 10,
                                    border: errors?.name ? errorBorder : baseBorder,
                                    background: "#fff",
                                    padding: "0 14px",
                                    outline: "none",
                                    fontSize: 14,
                                    color: "rgba(15,23,42,0.85)",
                                    fontFamily: "Plus Jakarta Sans",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>

                        {/* DOB */}
                        <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "rgba(15,23,42,0.70)",
                                    fontWeight: 500,
                                    marginBottom: 8,
                                    textAlign: "left",
                                    fontFamily: "Plus Jakarta Sans",
                                }}
                            >
                                DOB
                            </div>

                            <div
                                ref={setFieldRef("dob")}
                                tabIndex={-1}
                                onClick={() => setUpdate_date(true)}
                                style={{
                                    position: "relative",
                                    fontFamily: "Plus Jakarta Sans",
                                    cursor: "pointer",
                                    outline: "none",
                                }}
                            >
                                <input
                                    value={formatDDMMYYYY(startDate)}
                                    placeholder="DD/MM/YYYY"
                                    readOnly
                                    style={{
                                        width: "100%",
                                        height: 44,
                                        borderRadius: 10,
                                        border: errors?.dob ? errorBorder : baseBorder,
                                        background: "#fff",
                                        padding: "0 40px 0 14px",
                                        outline: "none",
                                        fontSize: 14,
                                        color: "rgba(15,23,42,0.85)",
                                        fontFamily: "Plus Jakarta Sans",
                                        boxSizing: "border-box",
                                        cursor: "pointer",
                                    }}
                                />
                                <div
                                    style={{
                                        position: "absolute",
                                        right: 12,
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        opacity: 0.75,
                                        pointerEvents: "none",
                                    }}
                                >
                                    {/* icon */}
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <rect x="4" y="5.5" width="16" height="15" rx="3" stroke="rgba(15,23,42,0.75)" strokeWidth="1.6" />
                                        <path d="M8 3.8V7" stroke="rgba(15,23,42,0.75)" strokeWidth="1.6" strokeLinecap="round" />
                                        <path d="M16 3.8V7" stroke="rgba(15,23,42,0.75)" strokeWidth="1.6" strokeLinecap="round" />
                                        <path d="M4 9H20" stroke="rgba(15,23,42,0.75)" strokeWidth="1.6" strokeLinecap="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Row 2: Address + Post Code */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: isMobile ? "1fr" : "1.25fr 0.55fr",
                            gap: 16,
                            marginTop: 16,
                            fontFamily: "Plus Jakarta Sans",
                        }}
                    >
                        {/* Address */}
                        <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "rgba(15,23,42,0.70)",
                                    fontWeight: 500,
                                    marginBottom: 8,
                                    textAlign: "left",
                                    fontFamily: "Plus Jakarta Sans",
                                }}
                            >
                                Address
                            </div>
                            <textarea
                                ref={setFieldRef("address")}
                                placeholder="Your Address"
                                value={address}
                                onChange={setField("address", setAddress)}
                                style={{
                                    width: "100%",
                                    minHeight: isMobile ? 92 : 110,
                                    borderRadius: 10,
                                    border: errors?.address ? errorBorder : baseBorder,
                                    background: "#fff",
                                    padding: "12px 14px",
                                    outline: "none",
                                    fontSize: 14,
                                    color: "rgba(15,23,42,0.85)",
                                    fontFamily: "Plus Jakarta Sans",
                                    boxSizing: "border-box",
                                    resize: "none",
                                }}
                            />
                        </div>

                        {/* Post Code */}
                        <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "rgba(15,23,42,0.70)",
                                    fontWeight: 500,
                                    marginBottom: 8,
                                    textAlign: "left",
                                    fontFamily: "Plus Jakarta Sans",
                                }}
                            >
                                Post Code
                            </div>
                            <input
                                ref={setFieldRef("code")}
                                placeholder="Your Post code"
                                value={code}
                                onChange={setField("code", setCode)}
                                style={{
                                    width: "100%",
                                    height: 44,
                                    borderRadius: 10,
                                    border: errors?.code ? errorBorder : baseBorder,
                                    background: "#fff",
                                    padding: "0 14px",
                                    outline: "none",
                                    fontSize: 14,
                                    color: "rgba(15,23,42,0.85)",
                                    fontFamily: "Plus Jakarta Sans",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>
                    </div>

                    {/* Row 3: Home Telephone + Mobile */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                            gap: 16,
                            marginTop: 16,
                            fontFamily: "Plus Jakarta Sans",
                        }}
                    >
                        <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "rgba(15,23,42,0.70)",
                                    fontWeight: 500,
                                    marginBottom: 8,
                                    textAlign: "left",
                                    fontFamily: "Plus Jakarta Sans",
                                }}
                            >
                                Home Telephone No
                            </div>
                            <input
                                ref={setFieldRef("tele")}
                                placeholder="Your Telephone No."
                                value={tele}
                                onChange={setField("tele", setTele)}
                                style={{
                                    width: "100%",
                                    height: 44,
                                    borderRadius: 10,
                                    border: errors?.tele ? errorBorder : baseBorder,
                                    background: "#fff",
                                    padding: "0 14px",
                                    outline: "none",
                                    fontSize: 14,
                                    fontFamily: "Plus Jakarta Sans",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>

                        <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "rgba(15,23,42,0.70)",
                                    fontWeight: 500,
                                    marginBottom: 8,
                                    textAlign: "left",
                                    fontFamily: "Plus Jakarta Sans",
                                }}
                            >
                                Mobile No
                            </div>
                            <input
                                ref={setFieldRef("mob")}
                                placeholder="Your Mobile No."
                                value={mob}
                                onChange={setField("mob", setMob)}
                                style={{
                                    width: "100%",
                                    height: 44,
                                    borderRadius: 10,
                                    border: errors?.mob ? errorBorder : baseBorder,
                                    background: "#fff",
                                    padding: "0 14px",
                                    outline: "none",
                                    fontSize: 14,
                                    fontFamily: "Plus Jakarta Sans",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>
                    </div>

                    {/* Row 4: Email */}
                    <div style={{ marginTop: 16, fontFamily: "Plus Jakarta Sans" }}>
                        <div
                            style={{
                                fontSize: 14,
                                color: "rgba(15,23,42,0.70)",
                                fontWeight: 500,
                                marginBottom: 8,
                                textAlign: "left",
                                fontFamily: "Plus Jakarta Sans",
                            }}
                        >
                            E-mail address
                        </div>
                        <input
                            ref={setFieldRef("email")}
                            placeholder="Your Email."
                            value={email}
                            onChange={setField("email", setEmail)}
                            style={{
                                width: "100%",
                                height: 44,
                                borderRadius: 10,
                                border: errors?.email ? errorBorder : baseBorder,
                                background: "#fff",
                                padding: "0 14px",
                                outline: "none",
                                fontSize: 14,
                                fontFamily: "Plus Jakarta Sans",
                                boxSizing: "border-box",
                            }}
                        />
                    </div>

                    {/* Emergency contact */}
                    <div
                        style={{
                            marginTop: 18,
                            fontSize: 14,
                            fontWeight: 700,
                            color: "rgba(15,23,42,0.85)",
                            fontFamily: "Plus Jakarta Sans",
                            textAlign: "left",
                        }}
                    >
                        Emergency Contact details. Next of Kin
                    </div>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                            gap: 16,
                            marginTop: 14,
                            fontFamily: "Plus Jakarta Sans",
                        }}
                    >
                        <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                            <div style={{ fontSize: 13, color: "rgba(15,23,42,0.65)", marginBottom: 8, textAlign: "left", fontFamily: "Plus Jakarta Sans" }}>
                                Name
                            </div>
                            <input
                                ref={setFieldRef("e_name")}
                                placeholder="Name"
                                value={e_name}
                                onChange={setField("e_name", setEname)}
                                style={{
                                    width: "100%",
                                    height: 44,
                                    borderRadius: 10,
                                    border: errors?.e_name ? errorBorder : baseBorder,
                                    background: "#fff",
                                    padding: "0 14px",
                                    outline: "none",
                                    fontSize: 14,
                                    fontFamily: "Plus Jakarta Sans",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>

                        <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                            <div style={{ fontSize: 13, color: "rgba(15,23,42,0.65)", marginBottom: 8, textAlign: "left", fontFamily: "Plus Jakarta Sans" }}>
                                Contact No
                            </div>
                            <input
                                ref={setFieldRef("c_no")}
                                placeholder="Contact No."
                                value={c_no}
                                onChange={setField("c_no", setC_no)}
                                style={{
                                    width: "100%",
                                    height: 44,
                                    borderRadius: 10,
                                    border: errors?.c_no ? errorBorder : baseBorder,
                                    background: "#fff",
                                    padding: "0 14px",
                                    outline: "none",
                                    fontSize: 14,
                                    fontFamily: "Plus Jakarta Sans",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>
                    </div>

                    {/* Alternative person */}
                    <div
                        style={{
                            marginTop: 18,
                            fontSize: 14,
                            fontWeight: 700,
                            color: "rgba(15,23,42,0.85)",
                            fontFamily: "Plus Jakarta Sans",
                            textAlign: "left",
                        }}
                    >
                        Alternative person to contact
                    </div>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                            gap: 16,
                            marginTop: 14,
                            fontFamily: "Plus Jakarta Sans",
                        }}
                    >
                        <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                            <div style={{ fontSize: 13, color: "rgba(15,23,42,0.65)", marginBottom: 8, textAlign: "left", fontFamily: "Plus Jakarta Sans" }}>
                                Name
                            </div>
                            <input
                                ref={setFieldRef("e_name_2")}
                                placeholder="Name"
                                value={e_name_2}
                                onChange={setField("e_name_2", setEname_2)}
                                style={{
                                    width: "100%",
                                    height: 44,
                                    borderRadius: 10,
                                    border: errors?.e_name_2 ? errorBorder : baseBorder,
                                    background: "#fff",
                                    padding: "0 14px",
                                    outline: "none",
                                    fontSize: 14,
                                    fontFamily: "Plus Jakarta Sans",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>

                        <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                            <div style={{ fontSize: 13, color: "rgba(15,23,42,0.65)", marginBottom: 8, textAlign: "left", fontFamily: "Plus Jakarta Sans" }}>
                                Contact No
                            </div>
                            <input
                                ref={setFieldRef("c_no_2")}
                                placeholder="Contact No."
                                value={c_no_2}
                                onChange={setField("c_no_2", setC_no_2)}
                                style={{
                                    width: "100%",
                                    height: 44,
                                    borderRadius: 10,
                                    border: errors?.c_no_2 ? errorBorder : baseBorder,
                                    background: "#fff",
                                    padding: "0 14px",
                                    outline: "none",
                                    fontSize: 14,
                                    fontFamily: "Plus Jakarta Sans",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>
                    </div>

                    {/* Medical history */}
                    <div style={{ marginTop: 18, fontFamily: "Plus Jakarta Sans" }}>
                        <div
                            style={{
                                fontSize: 13,
                                color: "rgba(15,23,42,0.72)",
                                marginBottom: 10,
                                textAlign: "left",
                                fontFamily: "Plus Jakarta Sans",
                            }}
                        >
                            Medical History. Are there any medical conditions that you would be willing to disclose, that the club should be aware of for your own safety and wellbeing.
                        </div>

                        <textarea
                            ref={setFieldRef("medi_his")}
                            placeholder="Your text…"
                            value={medi_his}
                            onChange={setField("medi_his", setMedi_his)}
                            style={{
                                width: "100%",
                                minHeight: 110,
                                borderRadius: 10,
                                border: errors?.medi_his ? errorBorder : baseBorder,
                                background: "#fff",
                                padding: "12px 14px",
                                outline: "none",
                                fontSize: 14,
                                fontFamily: "Plus Jakarta Sans",
                                boxSizing: "border-box",
                                resize: "none",
                            }}
                        />
                    </div>

                    {/* Self disclosure box */}
                    <div
                        ref={setFieldRef("selfDisclosure")}
                        tabIndex={-1}
                        style={{
                            marginTop: 18,
                            background: "#EAF6FB",
                            borderRadius: 14,
                            padding: 14,
                            border: errors?.selfDisclosure ? errorBorder : "1px solid rgba(15,23,42,0.06)",
                            fontFamily: "Plus Jakarta Sans",
                            outline: "none",
                        }}
                    >
                        <div style={{ fontSize: 13, color: "rgba(15,23,42,0.80)", textAlign: "left", fontFamily: "Plus Jakarta Sans" }}>
                            Self Disclosure. Is there any reason that approving your membership could negatively impact on the club? Have you ever had any Club membership refused or withdrawn in the past? Y / N
                        </div>

                        <div style={{ display: "flex", gap: 18, marginTop: 10, alignItems: "center", fontFamily: "Plus Jakarta Sans" }}>
                            {/* YES */}
                            <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <input
                                    type="radio"
                                    name="selfDisclosure"
                                    checked={selfDisclosure === true}
                                    onChange={() => {
                                        setSelfDisclosure(true);
                                        setErrors((p) => ({ ...(p || {}), selfDisclosure: false }));
                                    }}
                                />
                                <span style={{ fontSize: 14, color: "rgba(15,23,42,0.80)" }}>Yes</span>
                            </label>

                            {/* NO */}
                            <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <input
                                    type="radio"
                                    name="selfDisclosure"
                                    checked={selfDisclosure === false}
                                    onChange={() => {
                                        setSelfDisclosure(false);
                                        setErrors((p) => ({ ...(p || {}), selfDisclosure: false }));
                                    }}
                                />
                                <span style={{ fontSize: 14, color: "rgba(15,23,42,0.80)" }}>No</span>
                            </label>
                        </div>
                    </div>

                    {/* Reference */}
                    <div style={{ marginTop: 18, fontFamily: "Plus Jakarta Sans" }}>
                        <div
                            style={{
                                fontSize: 13,
                                color: "rgba(15,23,42,0.72)",
                                marginBottom: 12,
                                textAlign: "left",
                                fontFamily: "Plus Jakarta Sans",
                            }}
                        >
                            Reference. Please supply the name and contact details of one person to contact regarding your application, or the current member who endorsed your application.
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 16, fontFamily: "Plus Jakarta Sans" }}>
                            <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                                <div style={{ fontSize: 13, color: "rgba(15,23,42,0.65)", marginBottom: 8, textAlign: "left", fontFamily: "Plus Jakarta Sans" }}>
                                    Name
                                </div>
                                <input
                                    ref={setFieldRef("r_name")}
                                    placeholder="Name"
                                    value={r_name}
                                    onChange={setField("r_name", setRname)}
                                    style={{
                                        width: "100%",
                                        height: 44,
                                        borderRadius: 10,
                                        border: errors?.r_name ? errorBorder : baseBorder,
                                        background: "#fff",
                                        padding: "0 14px",
                                        outline: "none",
                                        fontSize: 14,
                                        fontFamily: "Plus Jakarta Sans",
                                        boxSizing: "border-box",
                                    }}
                                />
                            </div>

                            <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                                <div style={{ fontSize: 13, color: "rgba(15,23,42,0.65)", marginBottom: 8, textAlign: "left", fontFamily: "Plus Jakarta Sans" }}>
                                    Contact No
                                </div>
                                <input
                                    ref={setFieldRef("r_no")}
                                    placeholder="Contact No."
                                    value={r_no}
                                    onChange={setField("r_no", setR_no)}
                                    style={{
                                        width: "100%",
                                        height: 44,
                                        borderRadius: 10,
                                        border: errors?.r_no ? errorBorder : baseBorder,
                                        background: "#fff",
                                        padding: "0 14px",
                                        outline: "none",
                                        fontSize: 14,
                                        fontFamily: "Plus Jakarta Sans",
                                        boxSizing: "border-box",
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Submit */}
                    <button
                        onClick={() => onSubmitMembership()}
                        style={{
                            marginTop: 18,
                            width: "100%",
                            height: 52,
                            border: "none",
                            borderRadius: 12,
                            background: "#2A8FB8",
                            color: "#FFFFFF",
                            fontSize: 18,
                            fontWeight: 700,
                            cursor: "pointer",
                            boxShadow: "0 14px 34px rgba(0,0,0,0.18)",
                            fontFamily: "Plus Jakarta Sans",
                        }}
                        onMouseDown={pressDown}
                       // onMouseUp={pressUp}
                        onMouseEnter={hoverIn1}
                        onMouseLeave={hoverOut4}
                        onTouchStart={pressDown}
                       // onTouchEnd={pressUp}
                    >
                        Submit Application
                    </button>
                </div>
            </div>

            {/* ✅ MEMBERSHIP FORM SECTION (below the big membership heading) */}

            <div
                style={{
                    width: isMobile ? "95%" : Math.round(screenWidth * 0.65),
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 18 : 28,
                    fontFamily: "Plus Jakarta Sans",
                }}
            >
                {/* MAIN HELP CARD */}
                <div
                    style={{
                        background: "#FFFFFF",
                        borderRadius: 28,
                        border: "1px solid rgba(15,23,42,0.08)",
                        boxShadow: "0 22px 70px rgba(15,23,42,0.10)",
                        padding: isMobile ? 18 : 28,
                        boxSizing: "border-box",
                    }}
                >
                    {/* Header row */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 18,
                        }}
                    >
                        {/* icon tile */}
                        <div
                            style={{
                                width: isMobile ? 50 : 68,
                                height: isMobile ? 50 : 68,
                                borderRadius: 18,
                                background: "#FFF4D6",
                                display: "grid",
                                placeItems: "center",
                                border: "1px solid rgba(217,119,6,0.16)",
                                flexShrink: 0,
                            }}
                        >
                            {/* check-in-circle icon */}
                            <svg width={isMobile ? 25 : 34} height={isMobile ? 25 : 34} viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path
                                    d="M20 12a8 8 0 1 1-4.7-7.3"
                                    stroke="#D97706"
                                    strokeWidth="2.2"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M20 6 11.5 14.5 8 11"
                                    stroke="#D97706"
                                    strokeWidth="2.2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>

                        <div
                            style={{
                                fontSize: isMobile ? 20 : 40,
                                fontWeight: 700,
                                letterSpacing: -0.8,
                                color: "#0B1220",
                                lineHeight: 1.05,
                                textAlign: "left",
                            }}
                        >
                            Need Help?
                        </div>
                    </div>

                    {/* Description */}
                    <div
                        style={{
                            marginTop: 18,
                            fontSize: isMobile ? 18 : 26,
                            lineHeight: isMobile ? "28px" : "40px",
                            color: "#5B6B83",
                            fontWeight: 500,
                            maxWidth: 1100,
                            textAlign: "left",
                        }}
                    >
                        If you're unsure about which session to attend or have specific questions about equipment, feel free to give our
                        Membership Secretary a call.
                    </div>

                    {/* Call card */}
                    <div
                        style={{
                            marginTop: isMobile ? 22 : 34,
                            background: "#F6FAFD",
                            border: "1px solid rgba(15,23,42,0.06)",
                            borderRadius: 22,
                            padding: isMobile ? 16 : 22,
                            width: isMobile ? "80%" : "min(620px, 70%)",
                            boxShadow: "0 10px 30px rgba(15,23,42,0.06)",
                        }}
                    >
                        <div
                            style={{
                                fontSize: isMobile ? 14 : 18,
                                fontWeight: 700,
                                letterSpacing: 0.6,
                                color: "#6B7C93",
                                textTransform: "uppercase",
                                textAlign: "left",
                            }}
                        >
                            CALL ALAN
                        </div>

                        {/* phone row */}
                        <a
                            href="tel:07710099200"
                            style={{
                                marginTop: 12,
                                display: "flex",
                                alignItems: "center",
                                gap: 14,
                                textDecoration: "none",
                            }}
                        >
                            <div style={{ color: "#0A74B8", display: "grid", placeItems: "center" }}>
                                <svg width={isMobile ? 26 : 30} height={isMobile ? 26 : 30} viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path
                                        d="M7.5 3.5h1.1c.7 0 1.3.5 1.5 1.2l.6 2.2c.2.6-.1 1.3-.6 1.7l-1 .8c1 1.9 2.6 3.5 4.5 4.5l.8-1c.4-.5 1.1-.8 1.7-.6l2.2.6c.7.2 1.2.8 1.2 1.5v1.1c0 1-.8 1.8-1.8 1.8C11 20.4 3.6 13 3.6 5.3c0-1 .8-1.8 1.8-1.8Z"
                                        stroke="currentColor"
                                        strokeWidth="2.0"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>

                            <div
                                style={{
                                    fontSize: isMobile ? 24 : 28,
                                    fontWeight: 700,
                                    color: "#0A74B8",
                                    letterSpacing: -0.6,
                                    lineHeight: 1,
                                }}
                            >
                                077 100 99 200
                            </div>
                        </a>
                    </div>

                    {/* availability */}
                    <div
                        style={{
                            marginTop: isMobile ? 18 : 22,
                            fontSize: isMobile ? 16 : 20,
                            color: "rgba(15,23,42,0.45)",
                            fontWeight: 600,
                            textAlign: "left",
                        }}
                    >
                        * Available Mon–Fri, 9am – 5pm
                    </div>
                </div>
            </div>

            {/* ✅ DOB MODAL (copy-paste) */}
            <ReactModal
                isOpen={update_date}
                onRequestClose={() => setUpdate_date(false)}
                shouldCloseOnOverlayClick
                shouldCloseOnEsc
                style={{
                    overlay: {
                        position: "fixed",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.55)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: screenWidth <= 480 ? 12 : 24,
                        zIndex: 999999,
                    },
                    content: {
                        position: "relative",
                        inset: "auto",
                        width: screenWidth <= 480 ? "96vw" : "min(92vw, 590px)",
                        maxHeight: "90vh",
                        overflow: "hidden",
                        backgroundColor: "#F1F5F9",
                        borderRadius: screenWidth <= 480 ? 12 : 14,
                        padding: 0,
                        border: "none",
                        boxShadow: "0 30px 90px rgba(0,0,0,0.35)",
                    },
                }}
            >
                {/* Header */}
                <div
                    style={{
                        height: 56,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderBottom: "1px solid rgba(15,23,42,0.10)",
                        position: "relative",
                        fontFamily: "Open Sans",
                        fontWeight: 700,
                        color: "#0B1220",
                        fontSize: 16,
                        background: "#F8FAFC",
                    }}
                >
                    Select Date of Birth

                    <button
                        type="button"
                        onClick={() => setUpdate_date(false)}
                        style={{
                            position: "absolute",
                            right: 10,
                            top: 10,
                            height: 36,
                            width: 36,
                            borderRadius: 10,
                            border: "1px solid rgba(15,23,42,0.12)",
                            background: "#FFFFFF",
                            cursor: "pointer",
                            fontSize: 18,
                            lineHeight: "34px",
                            color: "#0B1220",
                        }}
                        aria-label="Close"
                    >
                        ✕
                    </button>
                </div>

                {/* Body */}
                <div
                    style={{
                        padding: screenWidth <= 480 ? 12 : 18,
                        overflowY: "auto",
                        maxHeight: "calc(90vh - 56px)",
                        boxSizing: "border-box",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => {
                            if (!date) return;

                            setStartDate(date);

                            // ✅ dd/MM/yyyy
                            const dd = String(date.getDate()).padStart(2, "0");
                            const mm = String(date.getMonth() + 1).padStart(2, "0");
                            const yyyy = date.getFullYear();
                            setBDate(`${dd}/${mm}/${yyyy}`);

                            // ✅ clear DOB red border
                            setErrors((p) => ({ ...(p || {}), dob: false }));

                            setUpdate_date(false);
                        }}
                        inline
                        maxDate={new Date()}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        yearDropdownItemNumber={120}
                        scrollableYearDropdown
                    />
                </div>
            </ReactModal>

            {
                load === true ? (
                    <Lottie
                        animationData={waiting}
                        loop
                        style={{
                            width: "min(500px, 80vw)",
                            height: "min(500px, 80vw)",
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 9999,
                            pointerEvents: "none",
                        }}
                    />
                ) : null
            }


        </div>
    );
}

export default Membership;


{
    /*
             
    */
}
